'use strict';

var config = require('../../../config.js')
exports = module.exports = {
  // List of user roles
  userRoles: ['guest', 'user', 'admin'],
  facebook: config.facebook
};



//////////////////
// WEBPACK FOOTER
// ./server/config/environment/shared.js
// module id = 15
// module chunks = 0